import { useTranslation } from 'react-i18next'
import { ROOM_KINDS } from 'service/DormService'

import styles from './DormModals.module.scss'

export const BuildingEditModal = ({ editingBuilding, setEditingBuilding, onSave }) => {
  const { t } = useTranslation('common')
  return (
    <div className={styles.overlay} onClick={() => setEditingBuilding(null)}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h3>
          {editingBuilding.id ? t('dorm.modal_edit_building') : t('dorm.modal_new_building')}
        </h3>
        <div className={styles.field}>
          <label>{t('dorm.field_name')}</label>
          <input
            className="unv-input"
            value={editingBuilding.name || ''}
            onChange={(e) => setEditingBuilding({ ...editingBuilding, name: e.target.value })}
          />
        </div>
        <div className={styles.field}>
          <label>{t('dorm.field_address')}</label>
          <input
            className="unv-input"
            value={editingBuilding.address || ''}
            onChange={(e) => setEditingBuilding({ ...editingBuilding, address: e.target.value })}
          />
        </div>
        <div className={styles.field}>
          <label>{t('dorm.field_capacity')}</label>
          <input
            type="number"
            className="unv-input"
            value={editingBuilding.capacity || 0}
            onChange={(e) =>
              setEditingBuilding({ ...editingBuilding, capacity: Number(e.target.value) })
            }
          />
        </div>
        <div className={styles.actions}>
          <button className="unv-btn" onClick={() => setEditingBuilding(null)}>
            {t('common.cancel')}
          </button>
          <button className="unv-btn unv-btn--primary" onClick={onSave}>
            {t('common.save')}
          </button>
        </div>
      </div>
    </div>
  )
}

export const RoomEditModal = ({ editingRoom, setEditingRoom, buildings, onSave }) => {
  const { t } = useTranslation('common')
  return (
    <div className={styles.overlay} onClick={() => setEditingRoom(null)}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h3>{editingRoom.id ? t('dorm.modal_edit_room') : t('dorm.modal_new_room')}</h3>
        <div className={styles.field}>
          <label>{t('dorm.col_building')}</label>
          <select
            className="unv-input"
            value={editingRoom.building || ''}
            onChange={(e) =>
              setEditingRoom({ ...editingRoom, building: Number(e.target.value) })
            }
          >
            <option value="">—</option>
            {buildings.map((b) => (
              <option key={b.id} value={b.id}>{b.name}</option>
            ))}
          </select>
        </div>
        <div className={styles.field}>
          <label>{t('dorm.field_number_floor')}</label>
          <input
            className="unv-input"
            placeholder={t('dorm.field_number_placeholder')}
            value={editingRoom.number || ''}
            onChange={(e) => setEditingRoom({ ...editingRoom, number: e.target.value })}
            style={{ marginBottom: 6 }}
          />
          <input
            type="number"
            className="unv-input"
            placeholder={t('dorm.field_floor_placeholder')}
            value={editingRoom.floor || 1}
            onChange={(e) =>
              setEditingRoom({ ...editingRoom, floor: Number(e.target.value) })
            }
          />
        </div>
        <div className={styles.field}>
          <label>{t('dorm.field_kind_seats')}</label>
          <select
            className="unv-input"
            value={editingRoom.kind}
            style={{ marginBottom: 6 }}
            onChange={(e) => setEditingRoom({ ...editingRoom, kind: e.target.value })}
          >
            {Object.entries(ROOM_KINDS).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
          <input
            type="number"
            className="unv-input"
            placeholder={t('dorm.field_seats_placeholder')}
            value={editingRoom.capacity}
            onChange={(e) =>
              setEditingRoom({ ...editingRoom, capacity: Number(e.target.value) })
            }
          />
        </div>
        <div className={styles.field}>
          <label>{t('dorm.field_monthly_rate')}</label>
          <input
            type="number"
            step="0.01"
            className="unv-input"
            value={editingRoom.monthly_rate || 0}
            onChange={(e) => setEditingRoom({ ...editingRoom, monthly_rate: e.target.value })}
          />
        </div>
        <div className={styles.actions}>
          <button className="unv-btn" onClick={() => setEditingRoom(null)}>
            {t('common.cancel')}
          </button>
          <button className="unv-btn unv-btn--primary" onClick={onSave}>
            {t('common.save')}
          </button>
        </div>
      </div>
    </div>
  )
}

export const AssignModal = ({ assigning, setAssigning, students, onAssign }) => {
  const { t } = useTranslation('common')
  return (
    <div className={styles.overlay} onClick={() => setAssigning(null)}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h3>{t('dorm.settle_title')}</h3>
        <div className={styles.field}>
          <label>{t('dorm.col_student')}</label>
          <select
            className="unv-input"
            value={assigning.student || ''}
            onChange={(e) => setAssigning({ ...assigning, student: Number(e.target.value) })}
          >
            <option value="">—</option>
            {students.map((s2) => (
              <option key={s2.id} value={s2.id}>
                {s2.full_name || `${s2.surname} ${s2.first_name}`}
              </option>
            ))}
          </select>
        </div>
        <div className={styles.field}>
          <label>{t('dorm.field_contract_no')}</label>
          <input
            className="unv-input"
            value={assigning.contract_no || ''}
            onChange={(e) => setAssigning({ ...assigning, contract_no: e.target.value })}
          />
        </div>
        <div className={styles.field}>
          <label>{t('dorm.field_monthly_payment')}</label>
          <input
            type="number"
            step="0.01"
            className="unv-input"
            value={assigning.monthly_payment || 0}
            onChange={(e) => setAssigning({ ...assigning, monthly_payment: e.target.value })}
          />
        </div>
        <div className={styles.actions}>
          <button className="unv-btn" onClick={() => setAssigning(null)}>
            {t('common.cancel')}
          </button>
          <button className="unv-btn unv-btn--primary" onClick={onAssign}>
            {t('dorm.settle_btn')}
          </button>
        </div>
      </div>
    </div>
  )
}

export const PayModal = ({ paying, setPaying, onPay }) => {
  const { t } = useTranslation('common')
  return (
    <div className={styles.overlay} onClick={() => setPaying(null)}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h3>{t('dorm.pay_title')}</h3>
        <div className={styles.field}>
          <label>{t('dorm.field_year_month')}</label>
          <input
            type="number"
            className="unv-input"
            value={paying.period_year}
            onChange={(e) => setPaying({ ...paying, period_year: Number(e.target.value) })}
            style={{ marginBottom: 6 }}
          />
          <input
            type="number"
            className="unv-input"
            min={1}
            max={12}
            value={paying.period_month}
            onChange={(e) => setPaying({ ...paying, period_month: Number(e.target.value) })}
          />
        </div>
        <div className={styles.field}>
          <label>{t('dorm.field_amount')}</label>
          <input
            type="number"
            step="0.01"
            className="unv-input"
            value={paying.amount || 0}
            onChange={(e) => setPaying({ ...paying, amount: e.target.value })}
          />
        </div>
        <div className={styles.field}>
          <label>{t('dorm.field_receipt_no')}</label>
          <input
            className="unv-input"
            value={paying.receipt_no || ''}
            onChange={(e) => setPaying({ ...paying, receipt_no: e.target.value })}
          />
        </div>
        <div className={styles.actions}>
          <button className="unv-btn" onClick={() => setPaying(null)}>
            {t('common.cancel')}
          </button>
          <button className="unv-btn unv-btn--primary" onClick={onPay}>
            {t('dorm.pay_btn_action')}
          </button>
        </div>
      </div>
    </div>
  )
}
